/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
import React from "react";
import { classNames } from "@plasmicapp/react-web";

export function Icon32Icon(props) {
  const { className, style, title, ...restProps } = props;
  return (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      xmlnsXlink={"http://www.w3.org/1999/xlink"}
      fill={"none"}
      viewBox={"0 0 20 20"}
      height={"1em"}
      className={classNames("plasmic-default__svg", className)}
      style={style}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <g
        stroke={"#292929"}
        strokeLinecap={"round"}
        strokeLinejoin={"round"}
        clipPath={"url(#a)"}
      >
        <path d={"M11.875 2.5v4.375h4.375"}></path>

        <path
          d={
            "M15 17.5h.625a.624.624 0 0 0 .625-.625v-10L11.875 2.5h-7.5a.625.625 0 0 0-.625.625V8.75"
          }
        ></path>

        <path
          d={
            "M8.75 11.875h-5a.625.625 0 0 0-.625.625v3.75c0 .345.28.625.625.625h5c.345 0 .625-.28.625-.625V12.5a.625.625 0 0 0-.625-.625m.625 1.563 2.5-1.563v5l-2.5-1.562"
          }
        ></path>
      </g>

      <defs>
        <clipPath id={"a"}>
          <path fill={"#fff"} d={"M0 0h20v20H0z"}></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export default Icon32Icon;
/* prettier-ignore-end */
